import api from '../../Axios'; // Your configured Axios instance

export interface AstrologyOnboardPayload {
  expertCode: string;
  expertName: string;
  categoryId: string;
  isAgreementSigned: boolean;
  isAcknowledged: boolean;
}

export const submitAstrologyOnboarding = async (data: AstrologyOnboardPayload) => {
  return api.post('/api/experts/astrology/onboard', data);
};